import { ReactNode } from "react";


interface NumberFieldProps {
  name: string;
  value?: string; 
  placeholder?: string;
  icon?: ReactNode;
  disabled?: boolean;
  hasError?: boolean;
  onChange?: (value: string) => void; 
  min?: number;   
  max?: number;   
  step?: number;  
}

const NumberField: React.FunctionComponent<NumberFieldProps> = ({
  name,
  value,
  icon,
  disabled,
  placeholder,
  hasError,
  onChange,
  min,
  max,
  step,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!onChange) return;

    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <div className="relative">
      {icon && (
        <div className={`input-icon ${disabled ? "disabled" : ""} ${hasError ? "error" : ""}`}>
          {icon}
        </div>
      )}

      <input

        type="number"
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        className={`input-field ${hasError ? "error" : ""}`}
        // Ha a `value` `undefined`, az input értéke üres string lesz
        value={value} 
        onChange={handleChange}
        min={min}
        max={max}
        step={step}
      />
    </div>
  );
};

export default NumberField;